import { render } from "./badgeSuccess.vue?vue&type=template&id=6ebb2112"
import script from "./badgeSuccess.vue?vue&type=script&lang=js"
export * from "./badgeSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cid_app/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__